import { RequestHelper } from "../utils";

const RUTA = "Installment";
export const InstallmentService = (() => {
  const create = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper().post(`${RUTA}/Installment`, data);
    });
  };

  const buscarPorId = function (args) {
    return new Promise((res) => res(args)).then((Id) => {
      return RequestHelper().get(`${RUTA}/Installment`, {
        Id: Id,
      });
    });
  };

  const pay = function (args) {
    return new Promise((res) => res(args)).then((Id) => {
      return RequestHelper().post(`${RUTA}/pay`, {
        Id: Id,
      });
    });
  };

  const actualizar = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper().patch(`${RUTA}/Installment`, data);
    });
  };

  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper().get(`${RUTA}/Installments`, params);
    });
  };
  return {
    create,
    buscarPorId,
    actualizar,
    listado,
    pay,
  };
})();
